<template>
  <div class="wrapper">
    <!-- <div class="botton-wrapper" :class="{show: !showLeft}"> -->
    <div class="botton-wrapper">
      <div class="botton left" @click="lock('left')">
        <i class="iconfont iconjiantou"></i>
      </div>
    </div>
    <div class="container">
      <div class="scroll-box" ref="scrollBox">
        <div class="item" v-for="(item, index) in listInfo.list" :key="item + '' + index">
          <div class="item-content">
            <h2 class="item-content-title">{{ item.title }}</h2>
            <p class="item-content-text">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="botton-wrapper" :class="{show: !showRight}"> -->
    <div class="botton-wrapper">
      <div class="botton right" @click="lock('right')">
        <i class="iconfont iconjiantou"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showLeft: false,
      showRight: true,
      islock: true,
      isMobile: document.body.clientWidth < 750
      // isButtonShowLeft: false,
      // isButtonShowRight: true
    }
  },
  props: ['listInfo'],
  methods: {
    // 控制滚动
    scroll (direction) {
      // 获取到 scrollBox, 并且获取其left值
      let width = this.isMobile ? 192 + 50 : 206
      let maxWidth = 0
      if (this.isMobile) {
        maxWidth = (this.listInfo.list.length - 1) * width - 20
      } else {
        maxWidth = 400
      }
      var oDom = document.getElementsByClassName('scroll-box')[0]
      var left = parseInt(window.getComputedStyle(oDom, null).left)

      // 边界判断
      if (direction === 'left' && left === 0) {
        return
      }
      if (direction === 'right' && left < -maxWidth) {
        return
      }

      // 计算赋值
      var afterLeft = direction === 'left' ? (left + width) : (left - width)
      // left = direction === 'left' ? (left + width) : (left - width)
      oDom.style.left = afterLeft + 'px'
      // console.log(left)
      // if (left < 206) {
      //   this.showLeft = false
      // } else {
      //   this.showLeft = true
      // }
      // if (left < -((this.listInfo.list.length - 2) * width)) {
      //   this.showRight = false
      // } else {
      //   this.showLeft = true
      // }
    },
    // 防止滚动完成前 的继续点击 冲突
    lock (direction) {
      if (this.islock) {
        this.islock = false
        this.scroll(direction)
        setTimeout(() => {
          this.islock = true
        }, 600)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/app.sass";

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background: $bg-color;
  height: 140px;
  .botton-wrapper.show {
    opacity: 0;
  }
  .botton {
    width: 38px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
      border-radius: 50%;
      background-color: #fff;
      box-shadow:0px 2px 5px rgba(0, 0, 0, 0.06);
    }
    >i {
      font-size: $fontSize12;
    }
    &.left {
      >i {
        transform: rotate(180deg);
      }
    }
  }

  .container {
    position: relative;
    // border: 1px solid red;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0 26px;

    .scroll-box {
      display: flex;
      // align-items: flex-start;
      position: absolute; top: 0; left: 0;
      width: 1512px;
      height: 100%;
      transition: left 0.6s ease;
      .item {
        flex: none;
        display: flex;
        justify-content: center;
        padding-top: 30px;
        margin-right: 50px;
        // width: 206px;
        font-size: 16px;
        // border: 1px solid blue;
        box-sizing: border-box;
        .item-content {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .item-content-title {
            color: $font-color1;
            font-size: 18px;
            font-weight: 500;
            // margin-bottom: 4px;
            &::before {
              content: "";
              display: inline-block;
              width: 22px;
              height: 12px;
              margin-right: 5px;
              background-image: url('../../image/style.png');
              background-size: 100%;
              background-repeat: no-repeat;
              background-position: center;
            }
          }
          .item-content-text {
            width: 12em;
            font-size: $fontSize16;
            line-height: 22px;
            color: $font-color2;
            font-weight: 400;
          }
        }
      }
    }
  }
}

  @include mobile {
    .wrapper {
      .container {
        margin: 0 !important;
      }
      .botton-wrapper {
        width: 50px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .botton-wrapper.show {
        opacity: 0;
      }
      .botton {
        width: 25px;
        height: 25px;
        // background: linear-gradient(to right, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.9));
      }
    }
  }
</style>
